var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M44.915,54.466c0-25.711,21.323-46.63,47.536-46.63c26.21,0,68.463,10.338,68.463,36.049v169.435 c0,8.73,3.674,15.806-5.224,15.806H137.14c-3.616,4.884-9.403,8.063-15.947,8.063c-5.518,0-10.509-2.255-14.106-5.89 c-3.598,3.635-8.588,5.89-14.106,5.89s-10.509-2.255-14.106-5.89c-3.598,3.635-8.588,5.89-14.106,5.89 c-10.964,0-19.853-8.889-19.853-19.853c0-0.728,0-3.385,0-4.018V54.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M66.108,76.409c0-25.711,21.322-46.63,47.535-46.63 c13.99,0,32.55,2.947,46.817,9.603C155.85,16.961,117.072,7.837,92.45,7.837c-26.212,0-47.534,20.919-47.534,46.63v158.855 c0,0.632,0,3.288,0,4.018c0,10.964,8.889,19.853,19.853,19.853c0.493,0,0.976-0.039,1.459-0.074 C66.155,236.508,66.108,76.409,66.108,76.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CC63F"
    },
    d: "M91.644,7.837h0.806c-0.589,0-1.173,0.023-1.758,0.044C90.94,7.852,91.249,7.837,91.644,7.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F4F2"
    },
    d: "M139.983,54.466c0-25.711-21.322-46.63-47.532-46.63h327.1c26.21,0,47.532,20.918,47.532,46.63 v433.891c0,8.73-7.214,15.806-16.112,15.806H156.097c-8.898,0-16.114-7.076-16.114-15.806V213.321L139.983,54.466L139.983,54.466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M172.919,488.357V213.321V54.466c0-25.711-21.322-46.63-47.532-46.63H92.45 c26.21,0,47.532,20.919,47.532,46.63v158.855v275.035c0,8.73,7.216,15.806,16.114,15.806h32.936 C180.135,504.163,172.919,497.087,172.919,488.357z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 307.418,
    cy: 88.064,
    rx: 50.109,
    ry: 33.729
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M279.079,88.063c0-16.111,16.787-29.575,39.227-32.922 c-3.506-0.522-7.143-0.807-10.882-0.807c-27.674,0-50.109,15.102-50.109,33.728c0,18.629,22.435,33.73,50.109,33.73 c3.739,0,7.377-0.284,10.882-0.807C295.866,117.64,279.079,104.175,279.079,88.063z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M407.509,222.041h-96.653c-4.329,0-7.837-3.509-7.837-7.837c0-4.328,3.508-7.837,7.837-7.837h96.653 c4.329,0,7.837,3.509,7.837,7.837C415.346,218.532,411.838,222.041,407.509,222.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M407.509,269.061h-96.653c-4.329,0-7.837-3.509-7.837-7.837c0-4.328,3.508-7.837,7.837-7.837h96.653 c4.329,0,7.837,3.509,7.837,7.837C415.346,265.552,411.838,269.061,407.509,269.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M407.509,316.081h-96.653c-4.329,0-7.837-3.509-7.837-7.837s3.508-7.837,7.837-7.837h96.653 c4.329,0,7.837,3.509,7.837,7.837S411.838,316.081,407.509,316.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M254.693,222.041h-50.939c-4.329,0-7.837-3.509-7.837-7.837c0-4.328,3.508-7.837,7.837-7.837h50.939 c4.329,0,7.837,3.509,7.837,7.837C262.53,218.532,259.022,222.041,254.693,222.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M254.693,269.061h-50.939c-4.329,0-7.837-3.509-7.837-7.837c0-4.328,3.508-7.837,7.837-7.837h50.939 c4.329,0,7.837,3.509,7.837,7.837C262.53,265.552,259.022,269.061,254.693,269.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M254.693,316.081h-50.939c-4.329,0-7.837-3.509-7.837-7.837s3.508-7.837,7.837-7.837h50.939 c4.329,0,7.837,3.509,7.837,7.837S259.022,316.081,254.693,316.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M254.693,363.101h-50.939c-4.329,0-7.837-3.509-7.837-7.837c0-4.328,3.508-7.837,7.837-7.837h50.939 c4.329,0,7.837,3.509,7.837,7.837C262.53,359.592,259.022,363.101,254.693,363.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M407.509,169.796H203.754c-4.329,0-7.837-3.509-7.837-7.837c0-4.328,3.508-7.837,7.837-7.837 h203.755c4.329,0,7.837,3.509,7.837,7.837C415.346,166.287,411.838,169.796,407.509,169.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M407.509,412.212H203.754c-4.329,0-7.837-3.509-7.837-7.837s3.508-7.837,7.837-7.837h203.755 c4.329,0,7.837,3.509,7.837,7.837S411.838,412.212,407.509,412.212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78B591"
    },
    d: "M254.693,451.918h-50.939c-4.329,0-7.837-3.509-7.837-7.837c0-4.328,3.508-7.837,7.837-7.837h50.939 c4.329,0,7.837,3.509,7.837,7.837C262.53,448.41,259.022,451.918,254.693,451.918z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.478,88.063c0,23.309,25.453,41.567,57.946,41.567c32.493,0,57.946-18.259,57.946-41.567 c0-23.307-25.453-41.565-57.946-41.565S249.478,64.755,249.478,88.063z M349.696,88.063c0,14.036-19.358,25.894-42.272,25.894 s-42.272-11.859-42.272-25.894s19.358-25.892,42.272-25.892S349.696,74.029,349.696,88.063z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M467.083,429.975c4.329,0,7.837-3.509,7.837-7.837V54.466C474.92,24.434,450.08,0,419.549,0H92.45 C61.919,0,37.079,24.434,37.079,54.466v17.632c0,4.328,3.508,7.837,7.837,7.837s7.837-3.509,7.837-7.837V54.466 C52.752,33.076,70.56,15.673,92.45,15.673c21.889,0,39.696,17.403,39.696,38.793v168.626c-0.484,0.399-0.924,0.857-1.304,1.372 c-2.302,3.109-5.818,4.891-9.649,4.891c-3.229,0-6.26-1.266-8.537-3.566c-1.471-1.487-3.477-2.324-5.569-2.324 c-2.092,0-4.098,0.837-5.569,2.324c-2.277,2.3-5.308,3.566-8.537,3.566c-2.251,0-4.399-0.628-6.269-1.781v-42.51 c0-4.328-3.508-7.837-7.837-7.837c-4.328,0-7.837,3.509-7.837,7.837v42.51c-1.87,1.153-4.019,1.781-6.269,1.781 c-6.626,0-12.016-5.391-12.016-12.016V108.669c0-4.328-3.508-7.837-7.837-7.837s-7.837,3.509-7.837,7.837v108.669 c0,15.268,12.422,27.69,27.69,27.69c5.046,0,9.882-1.34,14.106-3.852c4.225,2.512,9.06,3.852,14.106,3.852s9.882-1.34,14.106-3.852 c4.225,2.512,9.06,3.852,14.106,3.852c3.804,0,7.527-0.807,10.954-2.295v245.623c0,13.037,10.745,23.643,23.951,23.643h294.873 c13.205,0,23.949-10.606,23.949-23.643v-34.871c0-4.328-3.508-7.837-7.837-7.837s-7.837,3.509-7.837,7.837v34.871 c0,4.395-3.713,7.969-8.276,7.969H156.097c-4.564,0-8.278-3.576-8.278-7.969V54.466c0-15.169-6.335-28.908-16.54-38.793h288.271 c21.889,0,39.696,17.403,39.696,38.793v367.672C459.246,426.467,462.754,429.975,467.083,429.975z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.e459549c9a3e269f7521bc7d2175d2a7.svg";
export { ForwardRef as ReactComponent };